import { combineReducers } from '@reduxjs/toolkit'
import sharedData from './data'

const reducer = combineReducers({
    sharedData,
})

export default reducer
